import { api } from '../api-client.config';

interface UploadFilesResponse {
  urls: string[];
}

export const uploadFiles = async (
  files: File[],
  prefix: string = ''
): Promise<UploadFilesResponse> => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append('files', file);
  });

  formData.append('prefix', prefix);

  const response: UploadFilesResponse = await api.post(
    '/files/upload',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response;
};

export const uploadFileWithName = async (
  file: File,
  fileName: string
): Promise<{ url: string }> => {
  const formData = new FormData();

  formData.append('file', file);
  formData.append('fileName', fileName);

  const response: { url: string } = await api.post(
    '/files/upload-named',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response;
};
